import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ScreenshareFilledIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.667 1.5C13.1531 1.50009 13.6191 1.69337 13.9629 2.03711C14.3066 2.38085 14.4999 2.8469 14.5 3.33301V12.667C14.4999 13.1531 14.3066 13.6192 13.9629 13.9629C13.6192 14.3066 13.1531 14.4999 12.667 14.5H8.62598V8.17578L10.2256 9.77539C10.4697 10.019 10.8655 10.0193 11.1094 9.77539C11.3531 9.53146 11.3529 9.13566 11.1094 8.8916L8.44238 6.22461C8.22899 6.01153 7.89964 5.98491 7.65723 6.14453L7.55859 6.22461L4.8916 8.8916C4.6478 9.13558 4.6479 9.53134 4.8916 9.77539C5.13572 10.019 5.53245 10.0193 5.77637 9.77539L7.37598 8.17578V14.5H3.33301C2.8469 14.4999 2.38085 14.3066 2.03711 13.9629C1.69337 13.6192 1.50009 13.1531 1.5 12.667V3.33301C1.50009 2.84689 1.69337 2.38085 2.03711 2.03711C2.38085 1.69337 2.8469 1.50009 3.33301 1.5H12.667Z"
      fill="currentColor"
    />
  </svg>
);
